import type { Dispatch, SetStateAction } from "react";
import type { FormType } from "../../components/types";

export const onDeletePairingForm = (
  index: number,
  setForms: Dispatch<SetStateAction<FormType[]>>,
) => {
  setForms(state => {
    const copy: FormType[] = [...state];
    copy.splice(index, 1);
    return copy;
  });
};
